import React from 'react';
import extendAppend from '@src/components/modal/__helper__/extend-append';
import Modal from '@src/components/modal';
import Link from '@src/components/link';

const styles = require('./index.less');

@extendAppend({ withoutDefaultWrapModal: true })
export default class CommonModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: true
    };
  }

  /**
   * 关闭弹窗
   */
  onCloseClick() {
    this.setState({ visible: false });
  }

  render() {
    const { visible } = this.state;
    const { desc, onConfirmClick } = this.props;
    return (
      <Modal visible={visible}>
        <div className="xfe-common-modal-root">
          <div className="xfe-main-content">
            <div className="xfe-group-1">
              <div className="xfe-layer-2" dangerouslySetInnerHTML={{ __html: `<div>${desc}</div>` }} />
              <div className={styles.btnGroup}>
                {/*<input*/}
                {/*  type="button"*/}
                {/*  value="取  消"*/}
                {/*  className={styles.inputButton}*/}
                {/*  onClick={() => {*/}
                {/*    this.onCloseClick();*/}
                {/*  }}*/}
                {/*/>*/}
                <input
                  type="button"
                  value="确  定"
                  className={styles.inputButton}
                  onClick={() => {
                    onConfirmClick();
                    this.onCloseClick();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/business-components/common-modal/index.js